<div [formGroup]="formGroup" [style.padding-left.px]="control.element.paddingLeft">
  <div [formArrayName]="getFormArrayName(control.element.id)">
    @for (templateFormGroup of templateFormGroups; track i; let i = $index) {
      <div class="array-control-group {{ control.element.minimum !== control.element.maximum ? 'array-control-group-list' : ''}}"
        >
        @for (customFormControl of templateFormGroup.customFormControls; track customFormControl) {
          <div [style.flex]="customFormControl.element.width">
            <app-dynamic-control [formGroup]="formGroup"
              [control]="customFormControl"
              [formGroupName]="i"
              [viewModel]="viewModel"
              [arrayIndex]="i"
            [controlCache]="controls"></app-dynamic-control>
          </div>
        }
        @if (i >= control.element.minimum || control.element.alwaysShowDeleteButton) {
          <div style="flex: 1; position: relative; display: flex; align-items: flex-end">
            <button id="btn-array-delete-{{i}}" class="btn btn-danger" style="width: 100px" (click)="onArrayDelete(control, i)">Delete <i class="fa-regular fa-trash-can"></i></button>
          </div>
        }
      </div>
    }
  </div>
  @if (formArray.errors) {
    <div style="margin-left: 15px">
      <ul>
        @for (error of formArray.errors | keyvalue; track error) {
          <li style="color: red">
            {{ error.value }}
          </li>
        }
      </ul>
    </div>
  }
  @if (control.element.minimum !== control.element.maximum && control.element.showAddButton === true) {
    <button id="btn-add-{{control.element.id}}"
      class="btn btn-primary btn-assessor"
      [disabled]="isArrayFull(control)"
    (click)="addTemplateItem(control)">Add Another</button>
  }
</div>
